<div class="dialog-header">
  <h2>Outer Transfer</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group">
    <label>Location</label>
    <input type="text" [(ngModel)]="form.location" />
  </div>

  <div class="checkbox-group">
    <input
      type="checkbox"
      id="outerProfile"
      [(ngModel)]="form.outerTransferCustomerProfile"
    />
    <label for="outerProfile">Outer Transfer Customer Profile</label>
  </div>

  <div class="form-group">
    <label>Search</label>
    <input type="text" [(ngModel)]="form.search" (ngModelChange)="onSearch()" />
  </div>

  <div class="form-group">
    <label>Customer Outer Transfer To</label>
    <input type="text" [(ngModel)]="form.customerOuterTransferTo" />
  </div>

  <div class="form-group">
    <label>Outer Transfer Note</label>
    <textarea [(ngModel)]="form.outerTransferNote" rows="4"></textarea>
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
